<div #container class="container">
  <div class="display">
    <img
      (swipeLeft)="handleSwipeLeft($event)"
      (swipeRight)="handleSwipeRight($event)"
      src="{{ currentPhoto | async }}"
      alt=""
    />
  </div>
</div>
